import { Empty } from 'common-front/src/components/empty/empty';
import { executeQuery } from 'common-front/src/components/graphql/graphql';
import { Mutations } from 'common-front/src/generated/graphqlHooks';
import { debugLog } from 'common/src/util/debug';
import { HeaventPaths } from 'common/src/util/paths/heaventPaths';
import * as React from 'react';
import { Route, Switch } from 'react-router';
import { Code } from './recrewteer/code';
import { ForgotPassword } from './recrewteer/forgotPassword';
import { SignInEmail } from './recrewteer/signInEmail';
import { SignUpCredentials } from './recrewteer/signUpCredentials';

const onSuccess = async (token: string) => {
    await executeQuery(Mutations.UserCreate, { token });

    window.location.href = HeaventPaths.HOME;
};

const onFailure = (e?: Error) => {
    if (e) {
        debugLog('Auth failure', e);
    }

    window.location.href = HeaventPaths.AUTH_SIGN_IN;
};

export const Auth = () => (
    <Switch>
        <Route exact path={HeaventPaths.AUTH_FORGOT_PASSWORD}>
            <ForgotPassword onSuccess={onSuccess} />
        </Route>

        <Route exact path={HeaventPaths.AUTH_SIGN_IN_EMAIL}>
            <SignInEmail onSuccess={onSuccess} />
        </Route>

        <Route exact path={HeaventPaths.AUTH_SIGN_IN_CODE}>
            <Code onFailure={onFailure} onSuccess={onSuccess} />
        </Route>

        <Route exact path={HeaventPaths.AUTH_SIGN_UP_CREDENTIALS}>
            <SignUpCredentials onSuccess={onSuccess} />
        </Route>

        <Route exact path={HeaventPaths.AUTH_SIGN_UP_CODE}>
            <Empty path={HeaventPaths.AUTH_SIGN_IN_EMAIL} />
        </Route>

        <Route>
            <Empty path={HeaventPaths.AUTH_SIGN_IN_EMAIL} />
        </Route>
    </Switch>
);
